<template>
  <div class="uni-real-test-start examDetailsOwn">
    <MyDataDialog ref="myDataDialog" @isValidationFace="isValidationFace" />
    <Face ref="face" v-if="isFace" :examBasicUuid="exam_id.toString()" @isValidationFace="isValidationFace" @isRouter="isRouter" />
    <i class="iconfont iconfanhui" @click="$router.go(-1)" style="font-size: 30px;position: absolute;margin: 10px 0 0 20px" ></i>
    <div class="container">
      <h1 class="title">{{ dataText.exam_title }}</h1>
      <h3 class="title">{{ dataText.exam_course_title }}</h3>
      <div class="real-content">
        <!-- <div class="img-box"></div> -->
        <div style="flex: 1">
          <div class="test-info">
            <p class="row">
              <span>
                科目： <em class="primary" style="font-style: normal" >{{ dataText.exam_course_title }}</em>
              </span>
              <span>堂次：{{ dataText.exam_hall_title }}</span>
              <!-- dataText.exam_hall_end_time ? dataText.exam_hall_end_time.split(' ')[1] : dataText.exam_hall_end_time -->
              <span style="width:40%">考试时间: {{ dataText.exam_hall_start_time }} - {{ dataText.exam_hall_end_time }}</span>
            </p>

            <p class="row">
              <span>
                考试总时长：
                <em
                  class="primary"
                  style="font-style: normal"
                >{{ dataText.exam_line_duration }}分钟</em>
              </span>
              <span>共计：{{ dataText.exam_line_question_total }}道题</span>
              <span>总分：{{ dataText.exam_line_total_score }}分</span>

            </p>
            <p class="row">
              <!-- <span>合格分：{{ dataText.exam_line_pass_score }}分</span> -->
            </p>
          </div>
          <div class="test-notice">
            <p class="tit">题型介绍：</p>
            <div style="white-space: pre-line;">
              <p v-html="dataText.exam_line_introduction"></p>
            </div>
          </div>
          <div class="test-notice">
            <p class="tit">考试须知：</p>
            <div style="white-space: pre-line;">
              <p v-html="dataText.exam_notice"></p>
            </div>
          </div>
          <br>
          <br>
          <!-- @click="noticeClick" -->
          <el-checkbox v-model="is_notice"> </el-checkbox><span class="is_notice">我已阅读考试须知</span> 
          <span class="onLineTips" @click="operationProcess">《线上考试操作流程》</span>
        </div>
      </div>
      <div
        class="pab20"
        style="text-align: center"
      >
        <!-- <el-button
          type="primary"
          class="start-btn"
          v-if="false"
          @click="startExam(0)"
          >开始练习</el-button
        > -->
        <el-button
          type="primary"
          class="start-btn"
          @click="startExamFun()"
        >开始考试</el-button>
      </div>
    </div>
    <el-dialog
      title="考试须知"
      :visible.sync="dialogVisible"
    >
      <div
        class="dialog"
        style="padding: 0 0 10%"
      >
        <div style="white-space: pre-line;">
          <p v-html="dataText.exam_notice"></p>
        </div>
      </div>
      <div style="text-align: center">
        <el-button
          type="primary"
         @click="dialogVisible = false;is_notice=true;"
        >我知道了</el-button>
      </div>
    </el-dialog>
    <!-- 线上考试操作流程 -->
    <!-- <el-dialog
      title="线上考试操作流程"
      :visible.sync="isShowOperationProcess"
    >
      <div
        class="dialog"
        style="padding: 0 0 10%"
      >
        <el-scrollbar style="width: 100%;height: 500px;">
          <pdf src="https://www.cqjtjxjy.com/static/student/2022-10/1665731236292217.pdf"></pdf>
          <iframe src="https://www.cqjtjxjy.com/static/student/2022-10/1665731236292217.pdf" width="100%" height="500px"></iframe>
        </el-scrollbar>
      </div>
      <div style="text-align: center">
        <el-button
          type="primary"
         @click="isShowOperationProcess = false;"
        >我知道了</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { examInfo, startExam } from "@/api/exam";
import { removeStore } from "@/utils/localStorage";
import { jsToFormData, isPCFun } from "@/utils/func";
import MyDataDialog from "./myDataDialog";
import Face from "./module/face";

// import pdf from 'vue-pdf' npm install --save vue-pdf 

export default {
  name: "examDetailsOwn",
  components: { MyDataDialog, Face },
  data() {
    return {
      is_notice: false,
      dataText: "",
      exam_id: this.$route.query.examId,
      // typeName: ["单选题", "多选题", "判断题", "填空题"],
      // paperModeHasKaoshi: true,
      // paperModeHasLianxi: true,
      isFace: false,
      dialogVisible: false,

      // 线上考试操作流程
      // isShowOperationProcess: false, 

      loading: null,  //等待
    };
  },
  watch: {
    $route() {
      this.exam_id = this.$route.query.examId;
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  destroyed() {
    this.loading = null;
  },
  methods: {
    // 线上考试操作流程
    operationProcess(){
      // this.isShowOperationProcess = true;
      open('https://www.cqjtjxjy.com/static/student/2022-10/1665736175057776.pdf', '_blank');
    },
    isValidationFace() {
      // 暂时不用人脸识别 
      // this.isFace = !this.isFace;
      this.isRouter();
    },
    async getData() {
      const params = {
        id: this.exam_id,
      };
      const res = await examInfo(params);
      if (res.code === 200) {
        this.dataText = res.result;

      }
    },

    startExamFun() {
      // let data = { id: this.exam_id };
      // startExam(data).then((res) => {
      //   if (res.code == 200) {
      //     this.$router.push({
      //       name: "newOnlineExam",
      //       query: data,
      //     });
      //   }
      // });
      // return;
      if (this.is_notice !== true) {
        this.$message.warning("请查看考试须知");
        return;
      }

      const isPC = isPCFun();
      if(!isPC){
          this.$alert('请使用pc端浏览器', '', {
              showClose: true,
              showCancelButton: false,
              showConfirmButton: false,
              closeOnPressEscape: false,
              center: true,
          });
          return;
      }
      
      // 检测浏览器是否支持且有摄像头
      this.checkCameraSupport().then(() => {
        this.loading.close();
        this.$refs["myDataDialog"].isOpen();
      }).catch(err => {
        console.error(err);
        this.loading.close();
        this.$message.error(err.message || "摄像头检测失败，请确保浏览器已授权摄像头权限且设备正常");
      });
    },
    // 检测浏览器是否支持且有摄像头
    checkCameraSupport() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return new Promise((resolve, reject) => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          reject(new Error("当前浏览器不支持摄像头访问，请使用Chrome现代浏览器"));
          return;
        }

        navigator.mediaDevices.getUserMedia({ video: true })
          .then((stream) => {
            // 获取成功，停止流以释放摄像头资源
            stream.getTracks().forEach(track => track.stop());
            resolve(true);
          })
          .catch((err) => {
            let msg = "无法访问摄像头";
            if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
              msg = "您已拒绝摄像头权限，请在浏览器设置中允许访问摄像头";
            } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
              msg = "未检测到摄像头设备";
            } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
              msg = "摄像头被其他应用占用，请关闭其他使用摄像头的程序";
            }
            reject(new Error(msg));
          });
      });
    },
    isRouter() {
      let data = { id: this.exam_id };
      this.$router.push({
        name: "onlineExamOwn",
        query: data,
      });
      // startExam(data).then((res) => {
      //   if (res.code == 200) {
      //     this.$router.push({
      //       name: "onlineExamOwn",
      //       query: data,
      //     });
      //   }
      // });
    },
    noticeClick() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.onLineTips{
  margin-left: 10px;
  color: #2E58FF;
  cursor: pointer;
}
.is_notice{
margin-left: 10px;
font: 12px sans-serif;
color:ffff66;
}
.uni-real-test-start {
  padding: $sideMargin;
  padding-bottom: 0;
  min-height: $menuH;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #fff;
    padding: 0 150px;
    min-height: inherit;
  }

  .real-content {
    display: flex;
    align-items: center;
    border-top: 1px solid $grayBorder;
    padding-top: 60px;
    margin-top: 40px;

    .img-box {
      width: 350px;
      height: 330px;
      margin-right: 40px;
      overflow: hidden;
      @include themeIcon("paper");
    }
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .start-btn {
    @include uni-primary-btn(123px, 34px);
    @include linearGradient("btn-start", "btn-end");
    margin-top: 75px;
  }
  .test-info {
    .row {
      height: 30px;
      line-height: 30px;

      span {
        display: inline-block;
        width: 30%;
      }
    }
  }

  .test-notice {
    border-top: 1px solid $grayBorder;
    line-height: 30px;
    margin-top: 40px;

    .tit {
      margin-top: 30px;
    }
  }
}
</style>
